import { useMemo } from 'react';

import { Review } from '@repo/ui/models/candidate';
import { Submission } from '@repo/api/open-calls/graphql';
import { useComments } from '../use-comments';
import { useCandidates } from '@/state';

export type CandidateAndReview = Submission & { reviews: Review[] };

export function useCandidate(
  candidateId: string,
): CandidateAndReview | undefined {
  const { data: comments } = useComments();
  const { data: candidates } = useCandidates();

  const candidate = useMemo(() => {
    const data = candidates.find(
      (x) => x._id === candidateId,
    ) as CandidateAndReview;
    if (data) {
      data.reviews = [];
      if (comments.length > 0) {
        data.reviews = comments;
      }
    }
    return data;
  }, [candidates, candidateId, JSON.stringify(comments)]);

  return candidate;
}
